import { GIPIAbstractDTO } from '@gipisistemas/ng-core';
import { ReportMostPurchasedProductDTO } from './most-purchased-product.dto';

export class ReportClientSummaryDTO extends GIPIAbstractDTO {

    /** Valor a receber */
    amountReceivable: number;

    /** A receber atrasado */
    amountReceivableInOverdue: number;

    /** A receber hoje */
    amountReceivableToday: number;

    /** Atraso médio */
    averageDelay: number;

    /** Bloqueado */
    blocked: boolean;

    /** Cheques devolvidos */
    bouncedChecks: number;

    /** Cheques a depositar */
    checksToDeposit: number;

    /** CNPJ */
    cnpj: string;

    /** CPF */
    cpf: string;

    createDate: Date;

    /** Saldo crédito/haver */
    creditBalance: number;

    /** Top 5 produtos mais comprados */
    topFiveMostPurchasedProductsList: ReportMostPurchasedProductDTO[];

    /** Nome */
    name: string;

    /** Número de cheques */
    numberChecks: number;

    /** Pendências boleto */
    pendingBillet: number;

    /** Pendências promissória */
    pendingStoreCredit: number;

    /** Compras */
    shopping: number;

    /** Total a receber */
    totalAmountReceivable: number;

}
